import _regenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import * as product from '@/api/product';
var state = {
  merCateList: [] /** 商户分类 **/,
  merProductLabelList: [] /** 商品标签 **/,
  sysCateList: [] /** 平台分类 **/,
  feeRate: {
    tech_service_rate: 0,
    third_pay_rate: 0
  },
  contributionRoundConfig: {
    enable: true,
    // 是否启用取整
    type: 'floor',
    // 取整方式: floor(向下取整), ceil(向上取整), round(四舍五入)
    multiple: 10 // 取整倍数
  }
};
var mutations = {
  SET_MerCateList: function SET_MerCateList(state, merCateList) {
    state.merCateList = merCateList;
  },
  SET_ProductLabelList: function SET_ProductLabelList(state, merProductLabelList) {
    state.merProductLabelList = merProductLabelList;
  },
  SET_SysCateList: function SET_SysCateList(state, sysCateList) {
    state.sysCateList = sysCateList;
  },
  SET_FeeRate: function SET_FeeRate(state, feeRate) {
    state.feeRate = feeRate || {
      tech_service_rate: 0,
      third_pay_rate: 0
    };
  },
  SET_ContributionRoundConfig: function SET_ContributionRoundConfig(state, config) {
    state.contributionRoundConfig = config || {
      enable: true,
      type: 'floor',
      multiple: 10
    };
  }
};
var actions = {
  /** 商户分类 */getMerCateSelect: function getMerCateSelect(_ref) {
    var commit = _ref.commit,
      dispatch = _ref.dispatch;
    return new Promise(function (resolve, reject) {
      product.categorySelectApi().then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                commit('SET_MerCateList', res.data);
                console.log(res.data);
                resolve(res);
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        reject(error);
      });
    });
  },
  /** 商品标签 */getProductLabel: function getProductLabel(_ref3) {
    var commit = _ref3.commit,
      dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      product.getProductLabelApi().then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                commit('SET_ProductLabelList', res.data);
                resolve(res);
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (error) {
        reject(error);
      });
    });
  },
  /** 平台分类 **/getSysCategoryList: function getSysCategoryList(_ref5) {
    var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
    return new Promise(function (resolve, reject) {
      product.categoryListApi().then(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                commit('SET_SysCateList', res.data);
                resolve(res);
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref6.apply(this, arguments);
        };
      }()).catch(function (error) {
        reject(error);
      });
    });
  },
  /** 商户费率 */getFeeRate: function getFeeRate(_ref7) {
    var state = _ref7.state,
      commit = _ref7.commit;
    // if (state.feeRate && (state.feeRate.tech_service_rate || state.feeRate.third_pay_rate)) {
    //   return Promise.resolve(state.feeRate)
    // }
    return product.productFeeRateApi().then(function (res) {
      commit('SET_FeeRate', res.data || {});
      // 如果返回了贡献值取整配置，也一并保存
      if (res.data && res.data.contribution_round_config) {
        commit('SET_ContributionRoundConfig', res.data.contribution_round_config);
      }
      return res;
    }).catch(function (error) {
      throw error;
    });
  },
  /** 获取贡献值取整配置 */getContributionRoundConfig: function getContributionRoundConfig(_ref8) {
    var state = _ref8.state,
      commit = _ref8.commit;
    return product.getContributionRoundConfigApi().then(function (res) {
      commit('SET_ContributionRoundConfig', res.data || {});
      return res;
    }).catch(function (error) {
      // 如果接口不存在或失败，使用默认配置
      commit('SET_ContributionRoundConfig', {
        enable: true,
        type: 'floor',
        multiple: 10
      });
      throw error;
    });
  }
};

/** tree去除 childList=[] 的结构**/
var _changeNodes = function changeNodes(data) {
  if (data.length > 0) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].isShow === false) {
        data[i].disabled = true;
      }
      if (!data[i].childList || data[i].childList.length < 1) {
        data[i].childList = undefined;
      } else {
        _changeNodes(data[i].childList);
      }
    }
  }
  return data;
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  changeNodes: _changeNodes
};